import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getCartCount, cvlData } from '../../../../redux/actions/trans/authAction';
import loginApi from '../../../../services/loginApi';
import ApiCall from '../../../../services/trans/trans';
import { getDecryptedItem, setEncryptedItem } from '../../../../helper/methods';

let api = new loginApi();
let api2 = new ApiCall();

const useInvestorCartDetail = () => {
    const [PAN, setPAN] = useState('');
    const [ClientType, setClientType] = useState('');
    const stateData = useSelector(state => state.Auth);
    const dispatch = useDispatch();

    useEffect(() => {

        if (typeof window !== 'undefined') {

            async function setInitials() {
                let clientTypeArr = localStorage.getItem('ClientType');
                let panNoArr = getDecryptedItem("uniqueKey");

                if (!panNoArr || !clientTypeArr) {
                    // Call PAN from Token.
                    // Call CVL API.
                    // Call ClientType API.
                    // Set localstorage.
                    let CustPAN = "";
                    let getPayload = {
                        apiName: "GetPanFromToken",
                        params: ""
                    }
                    let apiResponsePAN = await api2.commonGet(getPayload);
                    console.log("apiResponsePAN =========", apiResponsePAN);
                    if (apiResponsePAN?.data?.success === true) {
                        CustPAN = apiResponsePAN?.data?.data;
                        let CVLpayload = {
                            "apiName": "kycCheck",
                            "body": { panNo: CustPAN }
                        };
                        let kycResponse = await api.common(CVLpayload);

                        let payloadClientType = {
                            "apiName": "clientType",
                            "body": { panNo: CustPAN }
                        };
                        let clientTypeResponse = await api.common(payloadClientType);

                        localStorage.setItem('ClientType', JSON.stringify(clientTypeResponse?.data));
                        setEncryptedItem("uniqueKey", { panNo: CustPAN, nameAsOnPan: kycResponse?.data?.data?.nameAsOnPan });
                    }
                }

                // let panNoArr = getDecryptedItem("uniqueKey");
                if (panNoArr) {
                    let jsonData = panNoArr;
                    setPAN(jsonData.panNo);
                }
                // let clientTypeArr = localStorage.getItem('ClientType');
                if (clientTypeArr) {
                    let clientJsonData = JSON.parse(clientTypeArr);
                    setClientType(clientJsonData.data.existingClient);
                }
            }
            setInitials();

            var localData = getDecryptedItem("uniqueKey");
            if (localData) {
                var jsonData = localData;
                dispatch(cvlData({
                    pan: jsonData.panNo,
                    nameAsOnPan: jsonData.nameAsOnPan
                }))
            }
            var guestData = localStorage.getItem('isGuest');
            if (guestData) {
                var guestJsonData = JSON.parse(guestData);
            }
        }

        try {
            let panNo = stateData['cvlData']['pan'];

            dispatch(getCartCount({
                apiName: "GetCartCount",
                body: {
                    arnCode: "",
                    panNo: panNo,
                }
            }))
        } catch (error) { }


    }, [])

    let pendingCount = 0;
    var customerName = "";

    if (stateData['cvlData'] !== null) {
        customerName = stateData['cvlData']['nameAsOnPan'];
    }

    console.log("stateData['cartCountData']", stateData['cartCountData']);
    if (stateData['cartCountData'] !== null && stateData['cartCountData'] !== undefined) {
        if (stateData['cartCountData'].hasOwnProperty('pendingCount')) {
            pendingCount = stateData['cartCountData']['pendingCount'];
        }
    }

    return ({
        pendingCount,
        customerName
    })
}

export default useInvestorCartDetail